import { useQuery } from '@apollo/client';
import { ERROR_CODES } from '../../../../utils/errorCodes/errorCodes';
// eslint-disable-next-line max-len
import { GET_PLAYER_STAT_DISTRIBUTION } from '../../../../utils/hooks/apiQueries/playerStats/getPlayerStatDistributions';
import { getSliderMetric } from './MetricModal.dataManipulation';

export const useGetPlayerStatDistribution = (
  selectedMetrics,
  selectedPosition,
  statDefinitions,
) => {
  const { data, loading, error } = useQuery(GET_PLAYER_STAT_DISTRIBUTION, {
    context: {
      headers: {
        'Accept-Version': 'v2023q2',
      },
    },
    variables: {
      position: selectedPosition,
      statNames: selectedMetrics,
    },
    notifyOnNetworkStatusChange: true,
  });
  if (loading) {
    return { isLoading: true };
  }
  if (error) {
    console.error(ERROR_CODES.USE_STAT_DISTRIBUTION, error);
    return {
      isLoading: false,
      error,
    };
  }

  const metricStatDistribution = data?.playerStatDistributions?.map(
    (metric) => {
      const currentMetric = statDefinitions.find(
        (metricDef) => metricDef.key === metric.name,
      );
      const sliderMetric = getSliderMetric(currentMetric, metric);
      const sliderMin = sliderMetric.min;
      const sliderMax = sliderMetric.max;
      const { lowerIsBetter } = sliderMetric;
      return {
        ...currentMetric,
        value: lowerIsBetter ? [sliderMax, null] : [sliderMin, null],
        min: sliderMin,
        max: sliderMax,
      };
    },
  );

  return {
    isLoading: false,
    metricStatDistribution,
  };
};
